import { render } from "./AddEditRCSTemplateSettings.vue?vue&type=template&id=6cb87cf8"
import script from "./AddEditRCSTemplateSettings.vue?vue&type=script&lang=js"
export * from "./AddEditRCSTemplateSettings.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__